import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { TaxReason } from 'src/features/taxReasons/utils/types';

const RESOURCE = '/subscriptions/tax-reason/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    is_active?: boolean;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<TaxReason>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_TAX_REASONS_RESOURCE, useQueryHook as useListTaxReasons };
